// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__J1LZ1","form":"Contact_form__Hp1Bg","input":"Contact_input__luYix","send":"Contact_send__pUkW0","label":"Contact_label__ho1rK"};